<div class="sidebar" [class.sidebar--collapsed]="!isOpen">
  <div class="sidebar__header">
    @if (isOpen) {
      <div class="sidebar__group-header">
        <span class="sidebar__group-header-text">Settings</span>
      </div>
    }
    <button
      kendoButton
      type="button"
      (click)="toggleSidebar()"
      class="sidebar__toggle"
      [attr.aria-label]="isOpen ? 'Collapse menu' : 'Expand menu'"
      [svgIcon]="isOpen ? chevronLeftIconSvg : menuIconSvg"
    ></button>
  </div>
  <div class="sidebar__divider"></div>
  <nav class="sidebar__nav">
    <ul class="sidebar__menu-list">
      @for (item of menuItems; track item.route || $index) {
        @if (item.isDivider) {
          <li class="sidebar__menu-divider"></li>
        } @else {
          <li class="sidebar__menu-item-wrapper">
            <button
              kendoButton
              type="button"
              class="sidebar__menu-item"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: item.route === '/tenants' }"
              [routerLink]="item.route"
              [class.disabled]="item.isDisabled"
              [disabled]="item.isDisabled"
            >
              <kendo-svg-icon [icon]="getIcon(item.icon)" class="sidebar__menu-icon"></kendo-svg-icon>
              @if (isOpen) {
                <span class="sidebar__menu-text">{{ item.title }}</span>
              }
            </button>
          </li>
        }
      }
    </ul>
  </nav>
</div>
